import { createNS } from '@ontologies/core';

import { frontendIRIStr } from '../app/lib/iris';
import { removeTrailingSlash } from '../app/lib/libro/id';

const appSlashless = createNS(removeTrailingSlash(frontendIRIStr));

export default {
  ns: appSlashless,
};
